module.exports = __webpack_public_path__ + "static/15-myrra-0808d719044db4cb2725683e410947e7.jpg";